module.exports = __webpack_public_path__ + "media/images/add_fees-57bf00f9.svg";